import { readEnvVariable } from '../helpers';

export function getNodeEnv(): string {
  return readEnvVariable('NODE_ENV');
}
